import React from 'react';
import ImageUploading, { ImageListType } from 'react-images-uploading';

import * as S from './styles';
import * as T from 'common/types';

/* Inline, so each follows the box's `currentColor` through its hover state. */
const PlusIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeLinecap="round">
    <path d="M12 5v14M5 12h14" />
  </svg>
);

const PenIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 20h9" />
    <path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4z" />
  </svg>
);

interface IProps {
  label?: string;
  disabled?: boolean | undefined;
  onChange?: (e: T.Form.FileUpload) => void;
  style?: object;
  iconStyle?: object;
  error?: boolean;
  success?: boolean;
  message?: string | boolean;
  defaultImage?: string | null;
  icon?: string;
  accept?: [string];
  value?: T.Form.FileUpload;
}

const UploadIcon: React.FC<IProps> = ({
  value,
  style,
  error,
  success,
  message,
  onChange,
  defaultImage,
  accept = ['png', 'jpg', 'jpeg', 'webp'],
  label,
  iconStyle
}) => {
  const onChangeFile = (
    imageList: ImageListType
    // addUpdateIndex: number[] | undefined
  ) => {
    // data for submit
    // setImages(imageList as never[]);
    if (onChange) onChange(imageList[0] as unknown as T.Form.FileUpload);
  };

  return (
    <S.inputContainer style={style} className={error ? 'error' : success ? 'success' : ''}>
      {label ? <S.label>{label}</S.label> : ''}
      <ImageUploading value={[{ ...value }]} onChange={onChangeFile} maxNumber={1} acceptType={accept}>
        {({ imageList, onImageUpload, onImageUpdate, isDragging, dragProps }) => {
          const preview = imageList[0]?.dataURL || defaultImage;

          return (
            <S.InputBox
              onClick={() => {
                imageList[0] ? onImageUpdate(0) : onImageUpload();
              }}
              {...dragProps}
              className={`${isDragging ? 'dragging' : ''} ${preview ? 'filled' : ''}`.trim()}
              title={preview ? 'Replace this image' : 'Add an image'}
            >
              {preview ? <S.img src={preview as string} className="icon" alt="" /> : <PlusIcon />}
              {preview ? (
                <S.Icon style={iconStyle}>
                  <PenIcon />
                </S.Icon>
              ) : (
                <></>
              )}
            </S.InputBox>
          );
        }}
      </ImageUploading>

      {message ? (
        <S.message className={error ? 'error-message' : success ? 'success-message' : ''}>{message}</S.message>
      ) : (
        <></>
      )}
    </S.inputContainer>
  );
};

export default UploadIcon;
